import { render } from "./Palindrome.vue?vue&type=template&id=854f5ea0&scoped=true&ts=true"
import script from "./Palindrome.vue?vue&type=script&lang=ts"
export * from "./Palindrome.vue?vue&type=script&lang=ts"

import "./Palindrome.vue?vue&type=style&index=0&id=854f5ea0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854f5ea0"]])

export default __exports__